// extracted by css-extract-rspack-plugin
module.exports =  {"match_slider_wrapper":"NOfhT","mrecadpos":"przqm","LandingPageslider":"Xwhjc"};